import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  if (process.server) return

  console.warn('Initializing sessionStorage vuex-persistedstate (flat, safe)')

  const modules = ['fb', 's', 'basket', 'HelpWidget'] // adjust as needed

  modules.forEach(moduleName => {
    createPersistedState({
      key: `${moduleName}`,
      paths: [moduleName],
      storage: window.sessionStorage,

      // Parse + unwrap safely (key-agnostic)
      getState: (key, storage) => {
        const raw = storage.getItem(key)
        if (!raw) return { [moduleName]: {} }
        try {
          const parsed = JSON.parse(raw)
          const value =
            parsed && typeof parsed === 'object' && Object.prototype.hasOwnProperty.call(parsed, moduleName)
              ? parsed[moduleName] // old wrapped shape: { [moduleName]: {...} }
              : parsed // new flat shape: { ... }
          return { [moduleName]: value ?? {} }
        } catch (e) {
          console.warn(`[session] Corrupted JSON for "${key}", clearing.`, e)
          storage.removeItem(key)
          return { [moduleName]: {} }
        }
      },

      // Save only the module payload (flat)
      setState: (key, state, storage) => {
        try {
          storage.setItem(key, JSON.stringify(state[moduleName] || {}))
        } catch (e) {
          console.warn(`[session] Failed to persist "${key}"`, e)
        }
      }
    })(store)
  })
}
